import React, { useState } from "react";
import DetailsTable from "./DetailsTable";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Table from "../../Table";
import { deleteProductItem } from "../../../../redux/reducer/productReducer";
import LoadingSpinner from "../../../animation/LoadingSpinner";

const PricedProduct = ({
  data,
  cartID,
  setEditingProducts,
  loading,
  refreshData,
}) => {
  const [editingOrder, setEditingOrder] = useState(null);
  const [pricingOrder, setPricingOrder] = useState(null);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  if (loading) {
    return <LoadingSpinner />;
  }
  // console.log(data)
  const headers = [
    "ID",
    "Prod. No",
    "Image",
    "Name",
    "Info",
    "Size",
    "Price Pro",
    "Fees",
    "Link",
    "Count",
    "Status",
    "Area",
    "total",
    "created At",
    "Actions",
  ];

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this Product?")) {
      dispatch(deleteProductItem(id))
        .unwrap()
        .then(() => {
          if (refreshData) refreshData();
        })
        .catch((error) => alert(error || "Failed to delete order."));
    }
  };

  const handleUpdate = (cartId) => {
    if (refreshData) refreshData();
  };

  // console.log(oneCart)
  return (
    <>
      <Table
        title={t("Priced Products")}
        headers={headers}
        data={data}
        EditingProducts={setEditingProducts}
        renderRow={(product, index) => (
          <DetailsTable
            key={product._id || index}
            index={index + 1}
            details={{
              id: product._id,
              number: index + 1,
              Box: product.ReferenceCode,
              link: product.link,
              info: product.additionalInfo,
              Count: product.count,
              history: product.createdAt,
              weight: product.weight,
              price: product.price || "00.0",
              status: product.status,
              DShippingFees: product.DShippingFees || "00.0",
              category: product.category,
              brand: product.brand,
              area: product.area,
              currency: product.currency,
              name: product.name,
              size: product.size,
              image:
                product.img || "https://api.markaship.com/uploads/waiting.png",
            }}
            isEditing={editingOrder === product._id}
            isPricing={pricingOrder === product._id}
            setEditingOrder={setEditingOrder}
            setPricingOrder={setPricingOrder}
            onDelete={() => handleDelete(product._id)}
            onUpdate={() => handleUpdate(cartID)}
            cartID={cartID}
            refreshData={refreshData}
          />
        )}
      />
    </>
  );
};

export default PricedProduct;
